import React, {  useState, useEffect } from "react";
import axios from "axios";
import { authHeader } from "../../../../../helpers";

const BookingSetFiles = ({ bookingId, setId }) => {


  const [files, setFiles] = useState([]);


  // ===========================
  // GET SET FILES
  // ===========================
  const fetchFiles = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_APIURL}reps/booking/booking-kit-files/${bookingId}`,
        {
          headers: authHeader(),
          params: {
            setId: setId
   
          }
        }
      );

      setFiles(res.data.files || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (setId) {
      fetchFiles();
    }
  }, [setId]);

 
  return (
    <div className="d-flex align-items-center flex-wrap">

      {files.map((file) => {

        const image =
          `${process.env.REACT_APP_APIURL}assets/uploads/kitDocuments/bookingFiles/${file.file_path}`;

        return (
          <div
            key={file._id}
            style={{
              position: "relative",
              marginRight: 8,
              marginBottom: 8,
            }}
          >
            <img
              src={image}
              alt=""
              width="55"
              height="55"
              style={{
                borderRadius: 5,
                objectFit: "cover",
                border: "1px solid #ddd",
                cursor: "pointer",
              }}
              onClick={() => window.open(image)}
            />

          </div>
        );
      })}

  
    </div>
  );
};

export default BookingSetFiles;